import { Component, OnInit } from '@angular/core';
import { ProfileService, SPSmtpService } from '../profile.service';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { Profile, ProfileForm } from '../model/model.class';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Theme } from '../../shared/service/AutoTheme';
import { AuthenticationService } from '../../authentication/authentication.service';
import { ProfileUpload } from '../../app-routing.module';
import { SmtpService } from '../../setting/setting.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent extends AppComponentClass<Profile, ProfileForm>{

  public showIcon;
  public iconFix: string;
  public packagedata = [];
  public ispackage: boolean;
  public loader: boolean;
  public spinner: boolean;
  public profile: any;
  public profile_image: string;
  public url: string;
  public issignup: boolean = false;
  public isvmsync: boolean = false;
  public issmtp: boolean = false;
  public keydata: string;
  public Profilepic = ProfileUpload + '/profileupload';
  agency_type: any = sessionStorage.getItem("agency_type");
  public demo1TabIndex = 0;
  entity: any;
  public usertype = parseInt(sessionStorage.getItem("type")) || 0;

  constructor(protected data: ProfileService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, protected theme: Theme, protected auth: AuthenticationService, private activatedroute: ActivatedRoute, public api: SPSmtpService) {
    super(data, router, fb, msg);
    this.keydata = sessionStorage.getItem("type");
    if (sessionStorage.getItem("type") == '2') {
      this.url = 'https://' + sessionStorage.getItem("domain") + '.ninjadialer.com/ManagerSignup?uuid=' + btoa(sessionStorage.getItem("userid") + '+' + sessionStorage.getItem("usercamp") + '+' + sessionStorage.getItem("domain"));
      this.issignup = true;
    }
    if (sessionStorage.getItem("type") == '3') {
      this.url = 'https://' + sessionStorage.getItem("domain") + '.ninjadialer.com/SupervisorSignup?uuid=' + btoa(sessionStorage.getItem("userid") + '+' + sessionStorage.getItem("usercamp") + '+' + sessionStorage.getItem("domain"));
      this.issignup = true;
    }

    if (sessionStorage.getItem("type") == '4' || sessionStorage.getItem("type") == '5') {
      if (sessionStorage.getItem("domain") == "sfg") {
        this.isvmsync = true;
      }
    }

    this.spinner = true;
    this.loader = false;
  }

  ngOnInit() {
    this.profile_image = sessionStorage.getItem("profile_image");

    let imgbasedir = location.origin;
    var imgexist = this.imageExists(imgbasedir + '/assets/profiles/' + this.profile_image);
    if (imgexist == 404) {
      this.profile_image = 'user.jpg';
    }


    this.data.getService("main").subscribe(res => {
      this.cdata = new ProfileForm(res[0]);
      this.profile_image = res[0].profile_image;
      let imgbasedir = location.origin;
      var imgexist = this.imageExists(imgbasedir + '/assets/profiles/' + this.profile_image);
      if (imgexist == 404) {
        this.profile_image = 'user.jpg';
      }
      
      this.data.Data = res[0];
      this.profile = res[0];
      console.log(this.profile);
      console.log(res);
      this.loader = true;
      this.spinner = false;
    });

    if (sessionStorage.getItem('type') == '1')
      this.ispackage = false;
    else
      this.ispackage = true;

    this.theme.profilepic.subscribe(res => {
      if (res != null && res != undefined) {
        this.profile_image = sessionStorage.getItem("profile_image");


        let imgbasedir = location.origin;
        var imgexist = this.imageExists(imgbasedir + '/assets/profiles/' + this.profile_image);
        if (imgexist == 404) {
          this.profile_image = 'user.jpg';
        }


        this.data.getService("main").subscribe(res => {
          this.cdata = new ProfileForm(res[0]);
          this.data.Data = res[0];
          this.profile = res[0];
          console.log(this.profile);
          sessionStorage.setItem("firstname", res[0].first_name);
          sessionStorage.setItem("email", res[0].email);
          this.loader = true;
          this.spinner = false;

        });
      }
    });

    this.data.GetRolesPermission({ iduser: sessionStorage.getItem("userid") }).subscribe(res => {
      if (res[0].smtp == 1)
        this.issmtp = true;
    });

    // this.data.getService("brandcamp").subscribe((res:any) => {
    //   this.api.SetData1(res[0])

    //   console.log("get entity", res[0]);
    //   this.entity=res[0].entity_type
    //   console.log("this.entity",this.entity);

    //   if (res[0].entity_type == 2 && res[0].status == 1 ) {
    //     this.iconFix = true;
    //   } else {
    //     this.iconFix = false;
    //   }
    // })
    var idPackage = sessionStorage.getItem('id_package');
    console.log("idPackage", idPackage);
    // get Entity Type
    this.auth.getEntityType(idPackage).subscribe(res => {
      console.log("get brand_Type", res[0].brand_type);
      this.showIcon = res[0].brand_type;
      if (this.showIcon == 2) {
        this.iconFix = 'gold';

      } else if (this.showIcon == 1) {
        this.iconFix = 'silver';
      } else {
        this.iconFix = '';
      }
    });

    // this.data.getService("brandcamps").subscribe((res: any) => {
    //   console.log(res[0].status);
    //   if ( res[0].status == 1)
    //        this.status=true
    // })


    /* this.data.getService("brandcamp").subscribe(res => {
      console.log(res);
      if (res) {
        this.smssetup = true;
        this.brand = res[0];
      }
      else
        this.smssetup = false;
    },
      err => {
        this.smssetup = false;
      }); */
    let params_Data = parseInt(this.activatedroute.snapshot.queryParamMap.get('type'))
    console.log(typeof params_Data);
    if (params_Data != 0)
      this.demo1TabIndex = params_Data
  }

  DeleteProfile() {
    let rconfirm = confirm("Are you sure, you want to Delete your Account?");
    console.log(rconfirm);
    if (rconfirm) {
      this.data.DeleteAccount().subscribe(res => {
        // this.brnd_unverify();
        this.openSnackBar(res.message, "Clear");
        this.auth.logout();
      },
        err => {
          this.openSnackBar("Something Wrong to Delete Account", "Clear");
        });
    }
  }

  onComplete(event: any) {
    sessionStorage.setItem("profile_image", event.filename);
    this.theme.ChangeProfilePic({ image: event.filename });
    sessionStorage.setItem("profile", JSON.stringify(event));
    this.ngOnInit();
  }

  brnd_unverify() {
    this.data.unvrfBrnd().subscribe(res => {
      if (res != '') {
        console.log("Hit working");

      }

    });
  }

  imageExists(image_url) {
    var http = new XMLHttpRequest();
    http.open('HEAD', image_url, false);
    http.send();
    return http.status;
  }

}